import { createAction, props } from "@ngrx/store";

export const setHasCheckoutError = createAction(
    "[Checkout page] Set Error status",
    props<{ value: boolean }>(),
);
